import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportCombustibleResumenDash(ctx: any, vrs: number): any {

    //vm.dateHour();
    var exportFileEx = [];
    var bol_datos_ex = false;

    var table_width = 16;// + (ctx.chkDateHour? 2: 1);
    //var vehiculo_width = 4 + (ctx.chkDateHour? 2: 1);
    var column_config = [];

    var codigo_cell_ch_width = "codigo".length;
    var placa_cell_ch_width = "placa".length;

    var fecha_inicio_gps_cell_ch_width = "Fecha Inicial".length;
    var hora_inicio_gps_cell_ch_width = "Fecha Inicio".length;
    var fecha_fin_gps_cell_ch_width = "Fecha Final".length;
    var hora_fin_gps_cell_ch_width = "Hora Fin".length;

    var distancia_recorrida_cell_ch_width = "Recorrido".length;

    var tiempo_movimiento_cell_ch_width = "Tiempo en Movimiento".length;
    var tiempo_relenti_cell_ch_width = "Tiempo Relenti".length;
    var tiempo_apagado_cell_ch_width = "Tiempo Apagado".length;
    var tiempo_parado_cell_ch_width = "Duración Paradas".length;

    var contador_paradas_cell_ch_width = "Contador Paradas".length;
    var velocidad_maxima_cell_ch_width = "Velocidad Máxima".length;
    var velocidad_promedio_cell_ch_width = "Velocidad Promedio".length;

    // var odometro_inicial_cell_ch_width = ctx.chkOdomV ? "Odómetro Virtual Inicial".length : "Odómetro Inicial".length;
    // var odometro_final_cell_ch_width = ctx.chkOdomV ? "Odómetro Virtual Final".length : "Odómetro Final".length;

    var header_two_lines = true;

    var allRows: AllRows[] = [
        {
          cells: [
            { value: ctx.report_data.rep_title, ...ctx.headerCellConfig, colSpan: table_width }
          ],
          height: ctx.headerRowsHeight
        },
        ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
    ];


    ctx.data.forEach((data: any,idx:any) => {

      if(data[1].length > 0){
        bol_datos_ex = true;

        var rows:AllRows[] = [
          {
            cells: [
              { value: ctx.report_data.rep_title, ...ctx.headerCellConfig, colSpan: table_width }
            ],
            height: ctx.headerRowsHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
          {
            cells: [
              // { value: "VEHÍCULO : " + data[0][1], color: "#FFF", background: "#000", vAlign: "center", hAlign: "center", fontSize: ctx.t2, colSpan: 2 },
              { value: "PERIODO", ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width },
            ],
            height: ctx.subHeaderHeight
          },
          {
            cells: [
              //{ value: data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width },
              { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width },
            ],
            height: ctx.subHeaderContentHeight
          },
          ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
        ];

        //if(ctx.chkDateHour) {

          rows.push({
            cells: [

              { value: "Item", ...ctx.colHeaderConfig },
              { value: "Código", ...ctx.colHeaderConfig },
              { value: "Placa", ...ctx.colHeaderConfig },

              { value: "Fecha Inicial", ...ctx.colHeaderConfig },
              { value: "Hora Inicio", ...ctx.colHeaderConfig },
              { value: "Fecha Final", ...ctx.colHeaderConfig },
              { value: "Hora Fin", ...ctx.colHeaderConfig },

              { value: "Recorrido", ...ctx.colHeaderConfig },

              { value: "Tiempo en Movimiento", ...ctx.colHeaderConfig },
              { value: "Tiempo Relenti", ...ctx.colHeaderConfig },
              { value: "Tiempo Apagado", ...ctx.colHeaderConfig },
              { value: "Duración Paradas", ...ctx.colHeaderConfig },

              { value: "Contador Paradas", ...ctx.colHeaderConfig },
              { value: "Velocidad Máxima", ...ctx.colHeaderConfig },
              { value: "Velocidad Promedio", ...ctx.colHeaderConfig },

              //=======================================
            ],
            height: header_two_lines? ctx.colsHeaderHeightTwoLine: ctx.colsHeaderHeight,
          });



          data[1].forEach((item: { odometro_fin:any; odometro_ini:any; tiempo_apagado:any; tiempo_relenti:any; 
            tiempo_parado:any;contador_paradas:any; velocidad_maxima:any; tiempo_movimiento:any; velocidad_promedio:any; rendimiento_por_galon:any; combustible_consumido:any; total_distancia:any; hora_final:any; fecha_final:any; hora_inicio:any; fecha_inicio: any;  latitud: number; longitud: number; codigo: any; placa: any; tipo_unidad: any; idConductor: any; conductor: any; nombre_zona: any; v0: any; velocidad: any;}, index: number) => {

            // var fh = item.fecha.split(" ");
            // var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";

            codigo_cell_ch_width = Math.max( codigo_cell_ch_width, (item.codigo??'').toString().length);
            placa_cell_ch_width = Math.max( placa_cell_ch_width, (item.placa??'').toString().length);

            fecha_inicio_gps_cell_ch_width = Math.max( fecha_inicio_gps_cell_ch_width, (item.fecha_inicio??'').toString().length);
            hora_inicio_gps_cell_ch_width = Math.max( hora_inicio_gps_cell_ch_width, (item.hora_inicio??'').toString().length);
            fecha_fin_gps_cell_ch_width = Math.max( fecha_fin_gps_cell_ch_width, (item.fecha_final??'').toString().length);
            hora_fin_gps_cell_ch_width = Math.max( hora_fin_gps_cell_ch_width, (item.hora_final??'').toString().length);

            distancia_recorrida_cell_ch_width = Math.max( distancia_recorrida_cell_ch_width, (item.total_distancia??'').toString().length);

            tiempo_movimiento_cell_ch_width = Math.max( tiempo_movimiento_cell_ch_width, (item.tiempo_movimiento??'').toString().length);
            tiempo_relenti_cell_ch_width = Math.max( tiempo_relenti_cell_ch_width, (item.tiempo_relenti??'').toString().length);
            tiempo_apagado_cell_ch_width = Math.max( tiempo_apagado_cell_ch_width, (item.tiempo_apagado??'').toString().length);
            tiempo_parado_cell_ch_width = Math.max( tiempo_parado_cell_ch_width, (item.tiempo_parado??'').toString().length);

            contador_paradas_cell_ch_width = Math.max( contador_paradas_cell_ch_width, (item.contador_paradas??'').toString().length);
            velocidad_maxima_cell_ch_width = Math.max( velocidad_maxima_cell_ch_width, (item.velocidad_maxima??'').toString().length);

            velocidad_promedio_cell_ch_width = Math.max( velocidad_promedio_cell_ch_width, (item.velocidad_promedio??'').toString().length);

            //=============================================

            rows.push({
              cells: [
                { value: (index + 1), ...ctx.bodyRowsConfig },
                { value: item.codigo, ...ctx.bodyRowsConfig },
                { value: item.placa, ...ctx.bodyRowsConfig },

                { value: item.fecha_inicio, ...ctx.bodyRowsConfig },
                { value: item.hora_inicio, ...ctx.bodyRowsConfig },
                { value: item.fecha_final, ...ctx.bodyRowsConfig },
                { value: item.hora_final, ...ctx.bodyRowsConfig },

                { value: item.total_distancia, ...ctx.bodyRowsConfig },

                { value: item.tiempo_movimiento, ...ctx.bodyRowsConfig },
                { value: item.tiempo_relenti, ...ctx.bodyRowsConfig },
                { value: item.tiempo_apagado, ...ctx.bodyRowsConfig },
                { value: item.tiempo_parado, ...ctx.bodyRowsConfig },

                { value: item.contador_paradas, ...ctx.bodyRowsConfig },
                { value: item.velocidad_maxima, ...ctx.bodyRowsConfig },
                { value: item.velocidad_promedio, ...ctx.bodyRowsConfig },

            

              ],
              height: ctx.bodyRowsHeight
            });
          });

        //}

        // //********************************************* excel version 1 *********************************
    if (vrs == 1) {

      column_config = [
        { width: ctx.w_item },
        { width: ctx.calculateColWidth(codigo_cell_ch_width) },
        { width: ctx.calculateColWidth(placa_cell_ch_width) },
        { width: ctx.w_date },
        { width: ctx.w_hour },
        { width: ctx.w_date },
        { width: ctx.w_hour },
      ];


      column_config.push(
        // { width: ctx.calculateColWidth(fecha_inicio_gps_cell_ch_width) },
        // { width: ctx.calculateColWidth(hora_inicio_gps_cell_ch_width) },
        // { width: ctx.calculateColWidth(fecha_fin_gps_cell_ch_width) },
        // { width: ctx.calculateColWidth(hora_fin_gps_cell_ch_width) },

        { width: ctx.calculateColWidth(distancia_recorrida_cell_ch_width) },

        { width: ctx.calculateColWidth(tiempo_movimiento_cell_ch_width) },
        { width: ctx.calculateColWidth(tiempo_relenti_cell_ch_width) },
        { width: ctx.calculateColWidth(tiempo_apagado_cell_ch_width) },
        { width: ctx.calculateColWidth(tiempo_parado_cell_ch_width) },

        { width: ctx.calculateColWidth(contador_paradas_cell_ch_width) },
        { width: ctx.calculateColWidth(velocidad_maxima_cell_ch_width) },
        { width: ctx.calculateColWidth(velocidad_promedio_cell_ch_width) },

      );




      exportFileEx.push({
      freezePane: {
        rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
        },
      columns: column_config,
      title: "Resultado",//data[0][1],
      rows: rows
      });

      codigo_cell_ch_width = "codigo".length;
      placa_cell_ch_width = "placa".length;

      fecha_inicio_gps_cell_ch_width = "Fecha Inicial".length;
      hora_inicio_gps_cell_ch_width = "Fecha Inicio".length;
      fecha_fin_gps_cell_ch_width = "Fecha Final".length;
      hora_fin_gps_cell_ch_width = "Hora Fin".length;

      distancia_recorrida_cell_ch_width = "Recorrido".length;

      tiempo_movimiento_cell_ch_width = "Tiempo en Movimiento".length;
      tiempo_relenti_cell_ch_width = "Tiempo Relenti".length;
      tiempo_apagado_cell_ch_width = "Tiempo Apagado".length;
      tiempo_parado_cell_ch_width = "Duración Paradas".length;

      contador_paradas_cell_ch_width = "Contador Paradas".length;
      velocidad_maxima_cell_ch_width = "Velocidad Maxima".length;
      velocidad_promedio_cell_ch_width = "Velocidad Promedio".length;

    }
    // //********************************************* excel version 1 *********************************

    // //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      rows.splice(0, ctx.headerRowSpan);
      rows.push(...ctx.spaceBetweenTables);
      allRows = allRows.concat(rows);
    }
    // //********************************************* excel version 2 *********************************


      }
    });

    //********************************************* excel version 2 *********************************
    if (vrs == 2) {
      allRows[0].cells![0].colSpan = table_width;

      column_config = [
        { width: ctx.w_item },
        { width: ctx.calculateColWidth(codigo_cell_ch_width) },
        { width: ctx.calculateColWidth(placa_cell_ch_width) },
        { width: ctx.w_date },
        { width: ctx.w_hour },
        { width: ctx.w_date },
        { width: ctx.w_hour },
      ];
      column_config.push(
        // { width: ctx.calculateColWidth(fecha_inicio_gps_cell_ch_width) },
        // { width: ctx.calculateColWidth(hora_inicio_gps_cell_ch_width) },
        // { width: ctx.calculateColWidth(fecha_fin_gps_cell_ch_width) },
        // { width: ctx.calculateColWidth(hora_fin_gps_cell_ch_width) },

        { width: ctx.calculateColWidth(distancia_recorrida_cell_ch_width) },

        { width: ctx.calculateColWidth(tiempo_movimiento_cell_ch_width) },
        { width: ctx.calculateColWidth(tiempo_relenti_cell_ch_width) },
        { width: ctx.calculateColWidth(tiempo_apagado_cell_ch_width) },
        { width: ctx.calculateColWidth(tiempo_parado_cell_ch_width) },

        { width: ctx.calculateColWidth(contador_paradas_cell_ch_width) },
        { width: ctx.calculateColWidth(velocidad_maxima_cell_ch_width) },
        { width: ctx.calculateColWidth(velocidad_promedio_cell_ch_width) },

      );

      exportFileEx.push({
        freezePane: {
          rowSplit: ctx.headerRowSpan
        },
        columns: column_config,
        title: "Resultado",//data[0][1],
        rows: allRows
      });
    }
    //********************************************* excel version 2 *********************************

    console.log("===>exportFileEx getFileExportCombustibleResumen", exportFileEx);  

    if (bol_datos_ex) {
        return exportFileEx;
    } else {
        return [];
    }

  }
